import React, { Component } from "react";

class IssueTooltip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      tooltipStyle: {}
    };
    this.tooltipref = null;
  }

  showTooltip = e => {
    const rect = e.currentTarget.getBoundingClientRect();
    const tooltipWidth = 420;
    const padding = 12;

    let left = rect.left + rect.width / 2 - tooltipWidth / 2;

    // clamp inside viewport
    left = Math.max(
      padding,
      Math.min(left, window.innerWidth - tooltipWidth - padding) + 5
    );

    this.setState(
      {
        tooltipStyle: {
          top: rect.top - 137,
          left,
          width: this.props.marginLeft ? 900 : ""
        },
        show: true
      },
      () => {
        if (!this.tooltipRef) return;

        const tooltipHeight = this.tooltipRef.offsetHeight || 100;
        const arrowHeight = 11;
        const spaceAbove = rect.top;

        let top;
        let showArrowTop;

        if (spaceAbove >= tooltipHeight) {
          top = rect.top - tooltipHeight;
          showArrowTop = true;
        } else {
          top = rect.bottom + arrowHeight;
          showArrowTop = false;
        }
        this.setState({
          arrowTop: showArrowTop,
          tooltipStyle: {
            top,
            left,
            width: this.props.marginLeft ? 900 : ""
          }
        });
      }
    );
  };

  hideTooltip = () => {
    this.setState({ show: false });
  };

  render() {
    const { show, tooltipStyle } = this.state;

    return (
      <span
        className="sparkle-wrapper"
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
        style={{ marginLeft: this.props.marginLeft ? "0px" : "auto" }}
      >
        {this.props.children}

        {show && (
          <div
            ref={el => (this.tooltipRef = el)}
            className="ai-hover-modal fixed"
            style={tooltipStyle}
          >
            {this.props.tooltipContent}
            <div
              style={{
                left:
                  this.props.activeTab == "AI Summary" && this.props.marginLeft
                    ? "23%"
                    : ""
              }}
              className={`ai-arrow ${this.state.arrowTop ? "top" : "bottom"}`}
            />
          </div>
        )}
      </span>
    );
  }
}

export default IssueTooltip;
